import { ChainId } from '@pancakeswap/chains'
import { GraphQLClient } from 'graphql-request'
import { infoStableSwapClient, v2Clients } from 'utils/graphql'
import { BLOCKS_CLIENT_WITH_CHAIN } from 'config/constants/endpoints'

export type MultiChainName = 'META_ASSETS' | 'META_ASSETS_TESTNET'

// Kept as an alias for backwards compatibility with downstream call sites
export type MultiChainNameExtend = MultiChainName

// Meta Assets chain genesis (block #1) timestamps — used as the lower bound for chart dayData queries
const META_ASSETS_MAINNET_START = 1779048781
const META_ASSETS_TESTNET_START = 1779353369

export const multiChainName: Record<number | string, MultiChainNameExtend> = {
  [ChainId.META_ASSETS]: 'META_ASSETS',
  [ChainId.META_ASSETS_TESTNET]: 'META_ASSETS_TESTNET',
}

export const multiChainShortName: Record<number, string> = {}

// Schema-suffix marker for subgraph queries (derived{X}, trackedReserve{X}, {x}Price).
// The macswap exchange subgraph kept Pancake's BNB-suffixed field names, so this stays 'BNB'
// even though the chain's native token is MA. This is not a UI label.
export const multiChainQueryMainToken: Record<MultiChainName, string> = {
  META_ASSETS: 'BNB',
  META_ASSETS_TESTNET: 'BNB',
}

export const multiChainBlocksClient: Record<MultiChainName, string> = {
  META_ASSETS: BLOCKS_CLIENT_WITH_CHAIN[ChainId.META_ASSETS],
  META_ASSETS_TESTNET: BLOCKS_CLIENT_WITH_CHAIN[ChainId.META_ASSETS_TESTNET],
}

// v2 Factory deployment block — the earliest block the exchange subgraph has data for.
// Used to clamp historical block-comparison aliases (1d/2d/7d/14d ago) so the subgraph
// doesn't reject the whole query when the chain is younger than 7d/14d.
export const multiChainStartBlock: Record<MultiChainName, number> = {
  META_ASSETS: 297226,
  META_ASSETS_TESTNET: 207033,
}

export const multiChainStartTime: Record<MultiChainName, number> = {
  META_ASSETS: META_ASSETS_MAINNET_START,
  META_ASSETS_TESTNET: META_ASSETS_TESTNET_START,
}

export const multiChainId: Record<MultiChainName, ChainId> = {
  META_ASSETS: ChainId.META_ASSETS,
  META_ASSETS_TESTNET: ChainId.META_ASSETS_TESTNET,
}

export const multiChainPaths = {
  [ChainId.META_ASSETS]: '',
  [ChainId.META_ASSETS_TESTNET]: '',
}

export const multiChainQueryClient: Record<MultiChainName, GraphQLClient> = {
  META_ASSETS: v2Clients[ChainId.META_ASSETS],
  META_ASSETS_TESTNET: v2Clients[ChainId.META_ASSETS_TESTNET],
}

export const multiChainScan: Record<MultiChainName, string> = {
  META_ASSETS: 'Meta Assets chain explorer',
  META_ASSETS_TESTNET: 'Meta Assets chain explorer',
}

export const multiChainTokenBlackList: Record<MultiChainName, string[]> = {
  META_ASSETS: [],
  META_ASSETS_TESTNET: [],
}

export const multiChainTokenWhiteList: Record<MultiChainName, string[]> = {
  META_ASSETS: [],
  META_ASSETS_TESTNET: [],
}

export const getMultiChainQueryEndPointWithStableSwap = (chainName: MultiChainName): GraphQLClient => {
  const isStableSwap = checkIsStableSwap()
  if (isStableSwap) return infoStableSwapClient
  return multiChainQueryClient[chainName]
}

// FIXME: this should be per chain
export const subgraphTokenName: Record<string, string> = {}

// FIXME: this should be per chain
export const subgraphTokenSymbol: Record<string, string> = {}

export const checkIsStableSwap = () => window.location.href.includes('stableSwap')

export const ChainLinkSupportChains: ChainId[] = []
